<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
<p class="ebook-toc" id="_idParaDest-1"><a id="_idTextAnchor000"></a> </p>
</div>
<div class="Basic-Text-Frame" id="_idContainer003">
<p class="Normal ParaOverride-1"><span class="text-italic CharOverride-1">To Gehad.</span></p>
</div>
<div class="Basic-Text-Frame pb" id="_idContainer004">
<p class="Normal ParaOverride-1"><span class="CharOverride-2">From His signs is that amongst yourselves He  created spouses for you to find tranquility in them;  and He put affection and mercy between you.</span></p>
<p class="Normal ParaOverride-1 t"><span class="CharOverride-2">(Quran 30:21)</span></p>
</div>
<div class="_idGenObjectLayout-1 t2">
<div id="_idContainer005">
<img alt="" class="_idGenObjectAttribute-1" src="image/Arranged--03.png" style="width: 40%;"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Arranged_ebook1.vue?7a513782